import { render, staticRenderFns } from "./CalculatorPersonalGainResultSmall.vue?vue&type=template&id=65d9c888&scoped=true"
import script from "./CalculatorPersonalGainResultSmall.vue?vue&type=script&lang=js"
export * from "./CalculatorPersonalGainResultSmall.vue?vue&type=script&lang=js"
import style0 from "./CalculatorPersonalGainResultSmall.vue?vue&type=style&index=0&id=65d9c888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9c888",
  null
  
)

export default component.exports